import React, { Component } from "react";
import { Row, Col, Image, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import RestaurantStyle from "./style";

// Helper
import {
  _renderRestaurantProfilePic,
  _renderCloseTime
} from "../../helpers/Utility";

// Redux
import { connect } from "react-redux";
import * as actions from "../../redux/actions";

class RestaurantCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (this.props.restaurantID)
      this.props.onLoadRestaurantDetail(this.props.restaurantID);
  }

  _goToRestaurantDetail = id => {
    this.props.history.push(`/restaurant/?restaurant=${id}`);
  };

  render() {
    const { restaurantDetail } = this.props;
    return (
      <RestaurantStyle>
        <div className="restaurant-card">
          <Row className="p-3 w-100 m-0">
            <Col xs={12} className="restaurant-card-profile d-flex p-0">
              <Image
                className="mx-auto"
                src={_renderRestaurantProfilePic(restaurantDetail.Media)}
              />
            </Col>
            <Col
              xs={12}
              className="restaurant-card-body p-0 my-3 d-flex flex-column align-items-center "
            >
              <div className="text-center my-2">
                <h3>
                  {restaurantDetail ? restaurantDetail.restaurant_name : ""}
                </h3>
                <p className="mb-1">
                  {restaurantDetail.openNow === 1 ? (
                    <span className="text-success">Open Now</span>
                  ) : restaurantDetail.RestaurantSetting.preorder === true &&
                    restaurantDetail.RestaurantSetting.preorder_now !== true ? (
                    <span className="text-success">Open Now</span>
                  ) : (
                    <span className="text-danger">
                      {_renderCloseTime(restaurantDetail)}
                    </span>
                  )}
                </p>

                {restaurantDetail.RestaurantSetting &&
                  restaurantDetail.RestaurantSetting.preorder === true && (
                    <p className="mb-1">Allowed Pre-Order </p>
                  )}

                {restaurantDetail.RestaurantSetting &&
                  restaurantDetail.RestaurantSetting.self_service === true && (
                    <p className="mb-1">Self Service </p>
                  )}
              </div>
              <Button
                className="py-2"
                variant="primary"
                block
                onClick={() =>
                  this._goToRestaurantDetail(restaurantDetail.restaurant_id)
                }
              >
                <b>Details</b>
              </Button>
            </Col>
          </Row>
        </div>
      </RestaurantStyle>
    );
  }
}

RestaurantCard.propTypes = {
  restaurantDetail: PropTypes.object.isRequired,
  // Function
  onLoadRestaurantDetail: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    restaurantDetail: state.Restaurant.restaurantDetail
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLoadRestaurantDetail: params =>
      dispatch(actions.getRestaurantDetail(params))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RestaurantCard)
);
